const en = {
  greeting_test: 'Hello !!!',
}

export default en
